var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 9.5V6.5H24.5V3.5H27.5V0.5H30.5V3.5H33.5V6.5H30.5V9.5H27.5ZM15.5 25.25C17.375 25.25 18.9688 24.5938 20.2812 23.2812C21.5938 21.9688 22.25 20.375 22.25 18.5C22.25 16.625 21.5938 15.0312 20.2812 13.7188C18.9688 12.4062 17.375 11.75 15.5 11.75C13.625 11.75 12.0312 12.4062 10.7188 13.7188C9.40625 15.0312 8.75 16.625 8.75 18.5C8.75 20.375 9.40625 21.9688 10.7188 23.2812C12.0312 24.5938 13.625 25.25 15.5 25.25ZM15.5 22.25C14.45 22.25 13.5625 21.8875 12.8375 21.1625C12.1125 20.4375 11.75 19.55 11.75 18.5C11.75 17.45 12.1125 16.5625 12.8375 15.8375C13.5625 15.1125 14.45 14.75 15.5 14.75C16.55 14.75 17.4375 15.1125 18.1625 15.8375C18.8875 16.5625 19.25 17.45 19.25 18.5C19.25 19.55 18.8875 20.4375 18.1625 21.1625C17.4375 21.8875 16.55 22.25 15.5 22.25ZM3.5 30.5C2.675 30.5 1.96875 30.2063 1.38125 29.6188C0.79375 29.0312 0.5 28.325 0.5 27.5V9.5C0.5 8.675 0.79375 7.96875 1.38125 7.38125C1.96875 6.79375 2.675 6.5 3.5 6.5H8.225L11 3.5H21.5V9.5H24.5V12.5H30.5V27.5C30.5 28.325 30.2063 29.0312 29.6188 29.6188C29.0312 30.2063 28.325 30.5 27.5 30.5H3.5Z",
    fill: "#141A1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPhoto);
export default __webpack_public_path__ + "static/media/UploadPhoto.0a5137376b16bf87819ee83d681bfdbb.svg";
export { ForwardRef as ReactComponent };